import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDino: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="dino, age, old"><path d="M16.75 5.5V11.4861H16.25C9.04425 7.083 7.15372 10.9567 5.36325 14.6254C4.22819 16.9511 3.13333 19.1944 0.75 19.1944H6.75V21.25H9.75V19.1944H13.75V21.25H16.75V18.6283C18.7899 17.6702 20.2024 15.5973 20.2024 13.1944V7.375L22.25 6.34722V5.5C22.25 3.98122 21.0188 2.75 19.5 2.75C17.9812 2.75 16.75 3.98122 16.75 5.5Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconDino;
